export const decodeResponsePayload = (response) => {
    const body = response?.body ?? response?.data
    const text = response?.text ?? body
    const payload = body && typeof body === "object"
        ? body
        : typeof text === "string" && text.trim()
            ? JSON.parse(text)
            : null

    if (payload && !Array.isArray(payload) && typeof payload === "object" && payload.detail) {
        throw new Error(String(payload.detail))
    }
    return payload
}

export const REPORT_ROUTINE_OPTIONS = [
    {value: "cliente_precos_log_workflow", label: "Cliente Preços Log"},
    {value: "curvas_workflow", label: "Curvas"},
    {value: "liquidez_workflow", label: "Liquidez"},
    {value: "precos_processados_workflow_v2", label: "Preços Processados V2"},
    {value: "precos_eventos_financeiros_workflow", label: "Preços Eventos Financeiros"},
    {value: "precos_eventos_lista_workflow", label: "Preços Eventos Lista"},
    {value: "precos_tunel_workflow", label: "Preços Túneis"},
    {value: "spreads_brutos_tratados_workflow", label: "Spreads Brutos Tratados"},
    {value: "spreads_negociados_workflow", label: "Spreads Negociados"},
    {value: "spreads_emissao_workflow", label: "Spreads Emissão"},
    {value: "spread_relativo_workflow", label: "Spread Relativo"},
    {value: "tratamento_risk_free_workflow", label: "Tratamento Risk Free"},
    {value: "curvas_volatilidade_workflow", label: "Curvas Volatilidade"},
]

const formatHeader = (key) => key
    .replace(/_/g, " ")
    .replace(/^\w/, (character) => character.toUpperCase())

export const buildReportDataTable = (payload) => {
    if (Array.isArray(payload)) {
        const fields = new Set()
        payload.forEach((item) => {
            Object.keys(item?.report || {}).forEach((key) => {
                if (key !== "metadata_output") fields.add(key)
            })
        })
        const reportFields = Array.from(fields)
        const rows = payload.map((item, index) => ({
            id: `${item.lote_id ?? "lote"}-${index}`,
            lote_id: item.lote_id ?? "",
            data_referencia: item.data_referencia ?? "",
            ...Object.fromEntries(reportFields.map((field) => {
                const value = item?.report?.[field]
                return [field, typeof value === "boolean" ? (value ? "Sim" : "Não") : value ?? ""]
            })),
        }))
        return {
            rows,
            columns: [
                {field: "lote_id", headerName: "Lote ID", minWidth: 120},
                {field: "data_referencia", headerName: "Data de referência", minWidth: 170},
                ...reportFields.map((field) => ({field, headerName: formatHeader(field), minWidth: 180, flex: 1})),
            ],
        }
    }

    if (payload && typeof payload === "object") {
        return {
            rows: Object.entries(payload).map(([key, value], index) => ({
                id: `${key}-${index}`,
                dados: key,
                qtde: value,
            })),
            columns: [
                {field: "dados", headerName: "Dados", minWidth: 240, flex: 1},
                {field: "qtde", headerName: "Quantidade", minWidth: 160},
            ],
        }
    }

    return {rows: [], columns: []}
}

export const buildDailyReportTable = (payload) => {
    const report = Array.isArray(payload?.relatorio_rotina) ? payload.relatorio_rotina : []
    if (report.length === 0) return {rows: [], columns: []}
    return {
        rows: report.map((item, index) => ({id: item.id ?? index, ...item})),
        columns: Object.keys(report[0]).map((key) => ({
            field: key,
            headerName: formatHeader(key),
            minWidth: 150,
            flex: 1,
        })),
    }
}
